import { useState } from 'react';
import { teamMembers } from '../../../mocks/ueber-uns';

export default function TeamSection() {
  const [activeId, setActiveId] = useState<number | null>(null);

  return (
    <section id="team" className="py-20 sm:py-24 bg-[#f5f1eb]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14 sm:mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest text-[#0D2B4E]/75 uppercase mb-3">
            Die Menschen hinter IGM Facility Service
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D2B4E] mb-4">Unser Team</h2>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
            Erfahrene Fachleute, die mit Herzblut dabei sind — hier stellen wir uns vor.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {teamMembers.filter((m) => m.id !== 1).map((member) => (
            <div
              key={member.id}
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden cursor-pointer hover:border-[#0D2B4E]/30 transition-all"
              onClick={() => setActiveId(activeId === member.id ? null : member.id)}
            >
              {/* Image or Icon Placeholder */}
              <div className="relative w-full h-64 overflow-hidden bg-[#f0ece4]">
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#0D2B4E]/8 to-[#0D2B4E]/3">
                    <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#0D2B4E]/10 border-2 border-dashed border-[#0D2B4E]/25">
                      <i className="ri-user-3-line text-4xl text-[#0D2B4E]/35" />
                    </div>
                    <span className="text-xs font-medium text-[#0D2B4E]/30 tracking-wider uppercase">Foto folgt</span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D2B4E]/65 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-bold text-lg leading-tight">{member.name}</p>
                  <p className="text-white/90 text-sm">{member.role}</p>
                </div>
              </div>

              {/* Skills */}
              <div className="p-5">
                <div className="flex flex-wrap gap-2 mb-4">
                  {member.skills.map((skill) => (
                    <span
                      key={skill}
                      className="text-xs font-medium text-[#0D2B4E] bg-[#0D2B4E]/10 border border-[#0D2B4E]/10 px-3 py-1 rounded-full"
                    >
                      {skill}
                    </span>
                  ))}
                </div>

                {/* Expandable description */}
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    activeId === member.id ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-sm text-gray-600 leading-relaxed mb-4">{member.description}</p>
                  <a
                    href={`tel:${member.phone}`}
                    className="inline-flex items-center gap-2 text-sm text-[#0D2B4E] font-semibold hover:underline cursor-pointer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-phone-line" />
                    </div>
                    Direkt kontaktieren
                  </a>
                </div>

                <button
                  className="flex items-center gap-1.5 text-xs font-semibold text-[#0D2B4E]/70 hover:text-[#0D2B4E] transition-colors mt-2 cursor-pointer whitespace-nowrap"
                >
                  <span>{activeId === member.id ? 'Weniger anzeigen' : 'Mehr erfahren'}</span>
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className={`ri-arrow-${activeId === member.id ? 'up' : 'down'}-s-line text-sm`} />
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
